import {useEffect, useState} from 'react';
import getFeatureFlag from 'utils/functions/getFeatureFlags';
import {getUserData} from 'utils/functions/getUserData/getUserData';
import {CTABanner} from '../CTABannersCarousel';

function useC5Banner({priority}: {priority: number}): CTABanner {
  const [shouldShowC5Banner, setShouldShowC5Banner] = useState(false);

  const {user} = getUserData();

  const isC5FlagOn = getFeatureFlag('c5_banner').isOn;

  useEffect(() => {
    if (isC5FlagOn) {
      if (sessionStorage.getItem('shouldShowC5Banner') === null) {
        setShouldShowC5Banner(true);
        sessionStorage.setItem('shouldShowC5Banner', 'true');
      }
    }
  }, [isC5FlagOn]);

  return {
    priority,
    title: 'Programa C5',
    theme: 'light',
    color: '#02c145',
    icon: ['fad', 'lightbulb-on'],
    description:
      'Você fez parte do Programa C5. Confira seu avanço e baixe seu certificado.',
    isVisible: () => shouldShowC5Banner,
    action: {
      text: 'Ver meu resultado',
      onClick: () =>
        window.open(`https://c5.letrus.com.br?pk=${user?.id}`, '_blank'),
    },
  };
}

export default useC5Banner;
